import type { DividendPayment, Holding, RealizedPosition } from '@tradekaro/shared';
import { genSeries } from '../dashboard/data';

export const PORTFOLIO_HOLDINGS: Holding[] = [
  { sym: 'ENGROH', name: 'Engro Holdings', sector: 'Conglomerate', qty: 250, avg: 281.4, current: 318.42, change: 2.14, color: 'oklch(0.55 0.18 35)', buyDate: 'Jan 14, 2025' },
  { sym: 'MEBL', name: 'Meezan Bank', sector: 'Banking', qty: 800, avg: 198.2, current: 226.9, change: 1.78, color: 'oklch(0.58 0.16 220)', buyDate: 'Mar 02, 2025' },
  { sym: 'LUCK', name: 'Lucky Cement', sector: 'Materials', qty: 120, avg: 762.8, current: 824.1, change: 1.42, color: 'oklch(0.68 0.14 75)', buyDate: 'Nov 22, 2024' },
  { sym: 'SYS', name: 'Systems Limited', sector: 'Tech', qty: 410, avg: 380.0, current: 412.55, change: 1.04, color: 'oklch(0.58 0.16 310)', buyDate: 'Jun 09, 2025' },
  { sym: 'HBL', name: 'Habib Bank', sector: 'Banking', qty: 1200, avg: 112.5, current: 118.65, change: 0.34, color: 'oklch(0.62 0.14 30)', buyDate: 'Aug 18, 2024' },
  { sym: 'TRG', name: 'TRG Pakistan', sector: 'Tech', qty: 1500, avg: 48.2, current: 62.18, change: 4.22, color: 'oklch(0.62 0.16 280)', buyDate: 'Feb 05, 2025' },
  { sym: 'FFBL', name: 'Fauji Fert Bin', sector: 'Fertilizer', qty: 2200, avg: 41.8, current: 38.24, change: 3.41, color: 'oklch(0.6 0.14 130)', buyDate: 'Sep 11, 2025' },
];

PORTFOLIO_HOLDINGS.forEach((h) => {
  h.series = genSeries(h.current ?? h.avg, h.change ?? 0, 30, 0.5);
});

export interface PerfRange {
  points: number;
  change: number;
  series: number[];
}

const buildPerf = (): Record<string, PerfRange> => {
  const cfg: Record<string, PerfRange> = {
    '1D': { points: 78, change: 1.01, series: [] },
    '1W': { points: 35, change: 2.84, series: [] },
    '1M': { points: 30, change: 5.12, series: [] },
    '3M': { points: 60, change: 8.94, series: [] },
    '1Y': { points: 52, change: 18.42, series: [] },
    ALL: { points: 80, change: 41.2, series: [] },
  };
  Object.values(cfg).forEach((c) => {
    c.series = genSeries(1842650.4, c.change, c.points, 0.55);
  });
  return cfg;
};

export const PORTFOLIO_PERF = buildPerf();

export const REALIZED: RealizedPosition[] = [
  { sym: 'OGDC', name: 'Oil & Gas Devco', qty: 200, avgBuy: 138.2, avgSell: 144.05, closed: 'Apr 24, 2026', pnl: 1170 },
  { sym: 'PSO', name: 'Pakistan State Oil', qty: 150, avgBuy: 184.5, avgSell: 196.2, closed: 'Mar 18, 2026', pnl: 1755 },
  { sym: 'PPL', name: 'Pakistan Petroleum', qty: 300, avgBuy: 162.4, avgSell: 158.8, closed: 'Feb 28, 2026', pnl: -1080 },
  { sym: 'UBL', name: 'United Bank', qty: 400, avgBuy: 218.4, avgSell: 234.1, closed: 'Feb 12, 2026', pnl: 6280 },
  { sym: 'NESTLE', name: 'Nestlé Pakistan', qty: 8, avgBuy: 6240.0, avgSell: 6810.0, closed: 'Jan 30, 2026', pnl: 4560 },
  { sym: 'ENGROH', name: 'Engro Holdings', qty: 100, avgBuy: 268.4, avgSell: 295.2, closed: 'Dec 14, 2025', pnl: 2680 },
];

export const DIVIDENDS: DividendPayment[] = [
  { sym: 'ENGROH', date: 'Apr 24, 2026', perShare: 7.5, qty: 250, amount: 1875 },
  { sym: 'MEBL', date: 'Apr 02, 2026', perShare: 4.0, qty: 800, amount: 3200 },
  { sym: 'HBL', date: 'Mar 28, 2026', perShare: 2.25, qty: 1200, amount: 2700 },
  { sym: 'LUCK', date: 'Mar 15, 2026', perShare: 12.0, qty: 120, amount: 1440 },
];
